<template>

  <div class="content">
    <div class="container" style="padding-left: 10px">
      <div class="row">
        <div class="col-md-12 px-0" >
          <top-navbar :title="restaurantName"></top-navbar>
        </div>
        <div class="col-md-12" >
            <div class="row" style="background-color: #FFFFFF;padding-top: 2%">
                <div class="col-md-3 pl-5 pr-5 pt-5">
                    <div class="form-group">
                        <select class="form-control" v-model="year">
                            <option v-for="(item, index) in years" :key="index" :value="item"> {{item}} </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-3 pl-5 pr-5 pt-5">
                    <div class="form-group">
                        <select class="form-control" v-model="month">
                            <option value="0"> Select Month </option>
                            <option v-for="(item, index) in months" :key="index" :value="index+1"> {{item}} </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-3 p-5">
                    <div class="form-group">
                      <button @click="getBookingList" class="btn submitBtn">Submit</button>
                      <img v-if="showLoading" src="/img/loading.gif" alt="GIF" width="30" height="30">
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
// import { mapState } from 'vuex'
import TopNavbar from '../../layout/TopNavbar'
import axios from 'axios'
import * as XLSX from 'xlsx/xlsx.mjs';
import moment from 'moment'

export default {
  components: {
    TopNavbar
  },
  data () {
    return {
      jwtToken: '',
      years: [],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      year: new Date().getFullYear(),
      month: 0,
      showLoading: false,
      excel_header: [['Recived Date & Status', 'Customer Name', 'Phone', 'Guest Quantity', 'Booking Date Time']],
      export_data: [],
      excel_button: 'Excel',
      restaurantName: localStorage.getItem('restaurantName')
    }
  },
  created() {
    this.jwtToken = this.$cookies.get('token') || null
  },
  mounted() {
    this.setData()
  },
  methods: {
    setData () {
      let curYear = new Date().getFullYear()
      for (let i = 2021; i <= curYear; i++) {
        this.years.push(i)
      }
    },
    getBookingList () {
      let id = parseInt(localStorage.getItem('restaurantId'))
      let url = ''
      if (!this.month) {
        this.$toastr.w("Please select month", "Warning")
        return
      }
      url = process.env.VUE_APP_API_URL+`/api/booking/bookingFilter?restaurantId=${id}&year=${this.year}&month=${this.month}`

      this.showLoading = true
      axios
      .get(url,
      {
        headers: {
          Authorization: `Bearer ${this.jwtToken}`,
        }
      })
      .then((data)=> {
        if (data.status == 200) {
          let bookings = data.data
          for (let i = 0; i < bookings.length; i++) {
            let item = []
            item.createdAt = moment(bookings[i].createdAt, 'DD.MM.YYYY').format('DD-MM-YYYY') + ' ' + bookings[i].status
            item.name = bookings[i].firstName + ' ' + bookings[i].lastName
            item.phone = bookings[i].phone
            item.guest = bookings[i].guest
            item.bookingDate = moment(bookings[i].date, 'DD.MM.YYYY').format('DD-MM-YYYY') + ' ' + moment(bookings[i].time, 'hh:mm A').format('hh:mm A')
            this.export_data.push(item)
          }
          // New method
          const wb = XLSX.utils.book_new();  // Had to create a new workbook and then add the header
          const ws =  XLSX.utils.json_to_sheet([]);
          XLSX.utils.sheet_add_aoa(ws, this.excel_header);

          //Starting in the second row to avoid overriding and skipping headers
          XLSX.utils.sheet_add_json(ws, this.export_data, { origin: 'A2', skipHeader: true });

          XLSX.utils.book_append_sheet(wb, ws, 'booking');

          // export Excel file
          XLSX.writeFile(wb, 'booking.csv')
        }
        this.showLoading = false
      })
    }
  }
}
</script>

<style scoped>
.submitBtn {
  background-color: #E317E3;
  color: white;
  border-color:  #E317E3;
}
</style>
